const defaultValueTransformator = {
  toModelAttribute(value) {
    if (value == null || value === "") {
      return null;
    }

    return value;
  },

  toFormAttribute(value) {
    if (value == null) {
      return "";
    }

    return `${value}`;
  },
};

export default defaultValueTransformator;
